namespace $.$$ {
	export class $shm_hitalama_extension_app extends $.$shm_hitalama_extension_app {

		@ $mol_mem
		maps() {
			return $shm_hitalama_profile.current()?.Maps_list(null)!
		}

		@ $mol_action
		add_map() {
			const entity = this.maps()?.make( [[ null, $giper_baza_rank_deny ]] )
			entity?.title( 'Новая карта' )
			return entity
		}

		@ $mol_mem
		map() {
			const widget = this.extension_widget_link()
			if( widget ) {
				const land = this.$.$giper_baza_glob.Land( widget.lord() )
				return land.Data( this.$.$shm_hitalama_map )
			}
			return this.maps().remote_list()?.at(0) ?? this.add_map()
		}

		@ $mol_mem
		extension_widget() {
			const ref = this.extension_widget_link()
			if( !ref ) return null
			return this.map().widget_by_link( ref )
		}
		
		login(): string {
			return this.$.$shm_hitalama_profile.current()?.Login()?.val() ?? ''
		}

		sub(): readonly ( any )[] {
			if( !this.login() ) return [this.Auth_gate()]
			if( !this.extension_widget_link() ) return [this.No_extension()]
			return this.extension_content()
		}

		extension_auto() {
			this.extension_fullscreen_sync()
			const widget = this.extension_widget()
			if( !widget ) return []
			this.extension_size_publish()

			const page = this.Map_page()
			const result = [ ...( page.Widget( widget.link() ).auto() ?? [] ) ]
			const source = widget.code_widget()
			if( source && source.link().str !== widget.link().str ) {
				result.push( ...( page.Widget( source.link() ).auto() ?? [] ) )
				result.push( this.map().runtime().widget_runner( source.link_str() ).run_if_enabled() )
			}
			return result
		}

		@ $mol_action
		extension_fullscreen_sync() {
			const id = this.extension_widget_link()?.str ?? ''
			if( this.$.$mol_state_arg.value( 'fullscreen_widget' ) !== id ) {
				this.$.$mol_state_arg.value( 'fullscreen_widget', id || null )
			}
			return id
		}

		@ $mol_mem
		extension_size_publish() {
			const widget = this.extension_widget()
			const height = Math.round( widget?.bottom_edge_y() ?? 0 )
			if( height <= 0 ) return null

			this.$.$shm_hitalama_extension_bridge.current().host( 'height', height )

			return height
		}

		extension_widget_link() {
			// Resolving remote() here would touch the selected root before its
			// read-only bootstrap can acquire the canonical Land instance.
			return this.$.$shm_hitalama_profile.current()?.Extension_current()?.val() ?? null
		}

		extension_widget_controls() {
			const widget = this.Map_page().Widget( this.extension_widget()!.link() )
			const controls = widget.Sub().controls()
			return controls.length > 0 ? controls : widget.Sub().drag_body()
		}

		extension_content() {
			const widget = this.Map_page().Widget( this.extension_widget()!.link() )
			return [ widget.Sub().Content_scroll() ]
		}
		
	}
}
